var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.time)?_c('div',{staticClass:"liveOrders-itemStatus"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"countdown",class:{
      blink: _vm.shouldBlink,
    }},[_c('TimeCountdown',{staticClass:"number",attrs:{"datetime":_vm.time,"output":"minutes","refresh":30},on:{"updated":_vm.countdownUpdated}}),_c('span',{staticClass:"min"},[_vm._v("min")])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }